import { createAction } from "typesafe-actions";
import { Key, State as LkfState } from "@linkfluence/core/state";

type Panel = LkfState[Key.Panel];

const TYPE = "/panel/open";

export default createAction(TYPE)<Panel>();
